import React from 'react';
import { Heading } from '@radix-ui/themes';

interface SectionHeadingProps {
  children: React.ReactNode;
  noTopMargin?: boolean;
  className?: string;
}

/**
 * SectionHeading - A standardized section heading component with consistent spacing
 * 
 * Uses Radix UI Heading with size="4" and includes:
 * - mt-8 (32px top margin) for separation from previous content (can be disabled with noTopMargin)
 * - mb-8 (32px bottom margin) for separation from following content
 * 
 * @param children - The heading text content
 * @param noTopMargin - If true, removes the top margin (useful for first section after page title)
 * @param className - Additional Tailwind classes to override or extend default styling
 */
const SectionHeading: React.FC<SectionHeadingProps> = ({ 
  children, 
  noTopMargin = false,
  className = '' 
}) => {
  const spacing = noTopMargin ? 'mb-6' : 'mt-8 mb-6';
  
  return (
    <div className={spacing}>
      <Heading size="4" className={`text-slate-800 ${className}`}>
        {children}
      </Heading>
    </div>
  );
};

export default SectionHeading;
